import { motion } from 'framer-motion'
import React from 'react';

interface IOverlayProps {
  children: React.JSX.Element
  close: (e: any) => void
}

export default function Overlay({ children, close }: IOverlayProps) {
  const variants = {
    open: { backgroundColor: 'rgba(0,0,0,0.85)' },
    closed: { backgroundColor: 'rgba(0,0,0,0)' },
  }

  return (
    <motion.div
      className="header-overlay"
      onClick={close}
      variants={variants}
      initial={'closed'}
      animate={'open'}
      exit={'closed'}
      key="overlay"
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: 100,
        left: 0,
        top: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </motion.div>
  )
}
